import React from 'react';
import { CoverPhotoImageSize } from 'ts/common';
import { IEvent } from '../types';
import BrandHomepageTile from './BrandHomepageTile';

interface IEventsLayoutProps {
    events: IEvent[];
}

const EventsLayout: React.FC<IEventsLayoutProps> = ({ events }) => {
    return (
        <>
            {events.map(({ coverPhoto, id, name, links }) => {
                const url = links.client.href;

                return (
                    <BrandHomepageTile
                        key={`event-${id}`}
                        coverPhoto={coverPhoto}
                        coverPhotoImageSize={CoverPhotoImageSize.Large}
                        linkText={name}
                        linkUrl={url}
                        useExternalLink={true}
                    />
                );
            })}
        </>
    );
};

export default EventsLayout;
